export type NotificationSyncBackend = "local" | "supabase";

export function getNotificationSyncBackend(): NotificationSyncBackend {
  const backend = process.env.NEXT_PUBLIC_NOTIFICATION_SYNC_BACKEND;
  if (backend === "local" || backend === "supabase") {
    return backend;
  }

  return "local";
}

export function shouldUseSupabaseNotificationSync(): boolean {
  return getNotificationSyncBackend() === "supabase";
}
